<template>
     <footer class="footer">
      <div class="footer-container container">
        <div class="footer-container-left">
          <div class="footer-container-left-list">
            <div class="footer-container-left-li" v-for="(item) in menuList" :key="item.id">
              <p @click="getChange(item.url,item.id)">{{item.title_name}}</p>
              <span v-for="(lineItem) in item.child" :key="lineItem.id" @click="getChange(lineItem.url,item.id)">{{lineItem.title_name}}</span>
              <!-- <span>视觉AI</span>
              <span>IOT</span>
              <span>智能仓储物流</span> -->
            </div>
            <!-- <div class="footer-container-left-li">
              <p>解決方案</p>
              <span>数字化工厂</span>
            </div>
            <div class="footer-container-left-li">
              <p>服务专区</p>
              <span>服务范围</span>
              <span>服务流程</span>
              <span>服务体系</span>
            </div>
            <div class="footer-container-left-li">
              <p>关于我们</p>
              <span>公司简介</span>
              <span>团队体系</span>
              <span>联系方式</span>
              <span>在线留言</span>
            </div> -->
          </div>
        </div>
        <div class="footer-container-center">
          <p>联系方式</p>
          <span><img src="../../assets/img/phone.png" alt="">17727680177</span>
          <span><img src="../../assets/img/email.png" alt="">po@ponfon.com</span>
          <span><img src="../../assets/img/position.png" alt="" style="vertical-align: middle;margin-top: -0.375rem;"><span style="width: 2.75rem;display: inline-block;word-wrap: break-word;"> 广东省深圳市龙岗区宝龙二路3号</span></span>
        </div>
        <div class="footer-container-right">
          <div class="footer-container-right-img">
            <img src="../../assets/img/erweima.png" alt="">
          </div>
          <div class="footer-container-right-title">扫一扫添加微信</div>
        </div>
        
      </div>
      <div class="footer-line"></div>
      <div class="footer-bottom container">
          <div class="beian">@2024 深圳市鹏沣智控技术有限公司. All rights reserved.　粤ICP备15057663号</div>
        </div>
    </footer>
</template>
<script>

import {getTitleList} from '@/api/index'
export default {
  name: 'FooterView',
  data(){
    return {
     menuList:[],

    }
  },
  components: {
  },
  created(){
    this.getTitleList();
  },
  methods:{
    getTitleList(){
        getTitleList().then((res)=>{
            let arr=[]
            arr=res.data
          this.menuList= arr.filter((item)=>{
              return item.url!='/home'&&item.url!='/news'&&item.url!='/servicelist'
            })
            this.menuList.forEach((item)=>{
              if(item.url=='/resolution'){
                item.child.push({title_name:"数字化工厂",url:"/resolution"})
              }else if(item.url=='/service'){
                item.child.push({title_name:"服务范围",url:"/service"},{title_name:"服务流程",url:"/service"},{title_name:"服务体系",url:"/service"},)
              }else if(item.url=='/about'){
                item.child.push({title_name:"公司介绍",url:"/about"},{title_name:"团队风采",url:"/about"},{title_name:"联系方式",url:"/about"},{title_name:"在线留言",url:"/about"})
              }
            })
        })

    },
    getChange(val,id){
      let str=val.split("/")[val.split("/").length-1]
      sessionStorage.setItem('title_id',id)
      sessionStorage.setItem('product',str)
      this.$router.push(val)
    }
  },
}
</script>
<style scoped lang="scss">
//  底部footer
.footer{
  position: relative;
  // margin-top: 1.25rem;
  // 
  bottom: 0;
  width: 100%;
  min-height: 4.55rem;
  padding-bottom: .125rem;
  background: url(../../assets/img/footer.png) no-repeat center center;
  background-size: cover;
  // margin-top: .75rem;
  .footer-container{
    display: flex;
    justify-content: space-between;
    padding-top: .9625rem;
    padding-bottom: .5rem;
    p{
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: $font-size18;
      color: #FFFFFF;
      // line-height: .325rem;
      text-align: left;
      margin-bottom:.1875rem;
    }
    span{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: $font-size16;
      color: #FFFFFF;
      // line-height: .275rem;
      text-align: left;
      display: block;
      margin-bottom: .125rem;
     
      img{
        width: .225rem;
        height: .225rem;
        margin-right: .1125rem;
      }
    }
    .footer-container-left{
      flex: 4;
      margin-right: 2.3125rem;
      .footer-container-left-list{
        display: flex;
        justify-content: flex-start;
        .footer-container-left-li{
          margin-right:.1875rem;
         p:hover{
          cursor: pointer;
         }
         span:hover{
          cursor: pointer;
         }
        }
         .footer-container-left-li:last-child{
          margin-right: 0;
         }
      }
    }
    .footer-container-center{
      flex: 2;
      p{
        font-size: $font-size18;
      }
      span{
        font-size: $font-size18;
      }
    }
    .footer-container-right{
      flex: 1;
      .footer-container-right-img{
        width: 1.4125rem;
        min-height: 1.425rem;
        margin-bottom: .125rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .footer-container-right-title{
        text-align: left;
        color: #fff;
        font-size: $font-size16;
      }
    }
   
  }
  .footer-line{
    position: absolute;
    bottom: .575rem;
    width: 100%;
    border: .0125rem solid rgba(255,255,255,0.2);
    margin-bottom: .25rem;
  }
  .footer-bottom{
    position: absolute;
    bottom: .15rem;
    
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 100%;
      .beian{
      
        text-align: center;
        color: #FFFFFF;
        font-size: $font-size16;
      }
    }
}
</style>